import { render, staticRenderFns } from "./SituacaoFiscalView.vue?vue&type=template&id=0b7909fc&"
import script from "./SituacaoFiscalView.vue?vue&type=script&lang=js&"
export * from "./SituacaoFiscalView.vue?vue&type=script&lang=js&"
import style0 from "./SituacaoFiscalView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports